import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import { defaultKSK2021_R01HeaderDto, defaultKSK2021_R01InspectDto, KSK2021_R01HeaderDto, KSK2021_R01InspectDto, KSK2021_R01DetailDto, defaultKSK2021_R01DetailDto } from './Dto_KSK2021_R01';
import { showWarning } from 'src/utils/toast/toastUtil';
import { getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';
import { WareHouseDto } from 'src/dtos/warehouse/wareHouseDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { calculateTotalOrderQty } from 'src/components/common/common';
import { getDetailGroupKey } from './Util_KSK2021_R01';


export interface KSK2021_R01Filter {
	labelPrintAuto: string;
}

export interface Store_KSK2021_R01 {
	KSK2021_R01Filter: KSK2021_R01Filter;
	KSK2021_R01PastFilter: KSK2021_R01Filter;
	setKSK2021_R01Filter: (filter: Partial<Store_KSK2021_R01['KSK2021_R01Filter']>) => void;
	setKSK2021_R01PastFilter: (filter: Store_KSK2021_R01['KSK2021_R01PastFilter']) => void;
	
	// ====== 생산실적 리스트 및 선택/편집 ======
	KSK2021_R01List: KSK2021_R01HeaderDto[];
	setKSK2021_R01List: (salesList: KSK2021_R01HeaderDto[]) => void;

	editKSK2021_R01: KSK2021_R01HeaderDto | null;
	setEditKSK2021_R01: (editHeader: KSK2021_R01HeaderDto | null) => void;

	// selectedKSK2021_R01: KSK2021_R01HeaderDto | undefined;
	// setSelectedKSK2021_R01: (data: KSK2021_R01HeaderDto | undefined) => void;
	// initSelectedKSK2021_R01: () => void;

	// ====== 자재출고 상세(디테일) 데이터 ======
	KSK2021_R01DetailList: KSK2021_R01DetailDto[];
	setKSK2021_R01DetailList: (data: KSK2021_R01DetailDto[]) => void;
	insertKSK2021_R01DetailList: (data: KSK2021_R01DetailDto[], index?: number) => void;
	removeKSK2021_R01DetailList: (index: number) => void;
	updateKSK2021_R01DetailList: (index: number, data: KSK2021_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedKSK2021_R01DetailList: string[];
	setSelectedKSK2021_R01DetailList: (idList: string[]) => void;
	addSelectedKSK2021_R01DetailList: (idList: string[]) => void;
	removeSelectedKSK2021_R01DetailList: (idList?: string[]) => void;
	initSelectedKSK2021_R01DetailList: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedKSK2021_R01DetailList: string[];
	setDeletedKSK2021_R01DetailList: (idList: string[]) => void;
	addDeletedKSK2021_R01DetailList: (idList: string[]) => void;
	removeDeletedKSK2021_R01DetailList: (idList?: string[]) => void;

	originalKSK2021_R01DetailList: KSK2021_R01DetailDto[];
	setOriginalKSK2021_R01DetailList: (data: KSK2021_R01DetailDto[]) => void;

	// ====== 생산실적 불량 상세(디테일) 데이터 ======
	KSK2021_R01InspectList: KSK2021_R01InspectDto[];
	setKSK2021_R01InspectList: (data: KSK2021_R01InspectDto[]) => void;
	insertKSK2021_R01InspectList: (data: KSK2021_R01InspectDto[], index?: number) => void;
	removeKSK2021_R01InspectList: (index: number) => void;
	updateKSK2021_R01InspectList: (index: number, data: KSK2021_R01InspectDto) => void;

	// ====== 선택(디테일) 불량 행 선택/삭제 관리 ======
	selectedKSK2021_R01InspectList: string[];
	setSelectedKSK2021_R01InspectList: (idList: string[]) => void;
	addSelectedKSK2021_R01InspectList: (idList: string[]) => void;
	removeSelectedKSK2021_R01InspectList: (idList?: string[]) => void;
	initSelectedKSK2021_R01InspectList: () => void;

	// ====== 생산실적 불량 상세(디테일) 행 선택/삭제 관리 ======
	deletedKSK2021_R01InspectList: string[];
	setDeletedKSK2021_R01InspectList: (idList: string[]) => void;
	addDeletedKSK2021_R01InspectList: (idList: string[]) => void;
	removeDeletedKSK2021_R01InspectList: (idList?: string[]) => void;

	originalKSK2021_R01InspectList: KSK2021_R01InspectDto[];
	setOriginalKSK2021_R01InspectList: (data: KSK2021_R01InspectDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;

	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	inspectColumnState: ColumnState[] | null;
	setInspectColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	

	notProductResult: boolean;
	setNotProductResult: (notProductResult: boolean) => void;

	modalVisible: boolean;
	setModalVisible: (modalVisible: boolean) => void;
	workTimeModalVisible: boolean;
	setWorkTimeModalVisible: (workTimeModalVisible: boolean) => void;
	workTimeModalType: 'start' | 'end' | null;
	setWorkTimeModalType: (type: 'start' | 'end' | null) => void;
	isDetailMaximized: boolean;
	setIsDetailMaximized: (value: boolean) => void;
	
	//화면의 초기 로드 플래그
	isInitialLoad: boolean;
	setIsInitialLoad: (isInitialLoad: boolean) => void;

	// ====== 초기화 ======
	initData: () => void;

	// 창고 코드 필터링
	warehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	outWarehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	badWarehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	// 공통코드 로드 후 초기값 동기화
	syncInitialData: () => void;

}

//각 Detail 행의 itemCd가 첫번째인지 검증하고. 첫번째라면 transportQty행에 bomUsingQty를 넣고, 아니라면 0을 넣는다.
export const takeDetailItemIsFirstIndex = (
	detailList: KSK2021_R01DetailDto[]
): number[] => {
	const firstValueIndices: number[] = [];
	const seenItemCds = new Set<string>();

	detailList.forEach((item) => {
		// childItemcd가 존재하고, 이전에 본 적 없는 값이라면
		if (item.childItemcd && !seenItemCds.has(item.childItemcd)) {
			// 방문 기록에 추가
			seenItemCds.add(item.childItemcd);
			// 결과 배열에 해당 행의 valueIndex 추가
			firstValueIndices.push(item.valueIndex);
		}
	});

	return firstValueIndices;
};

export const calculateBomUsingQty = (
	editKSK2021_R01: KSK2021_R01HeaderDto | null,
	detailItem: KSK2021_R01DetailDto,
): number => {
	if (!editKSK2021_R01) return detailItem.bomUsingQty;

	const productQty = Number(editKSK2021_R01.productQty) || 0;
	const fixLossqty = (productQty > 0) ? detailItem.fixLossqty || 0 : 0;
	const usage = detailItem.coordinateUsage || detailItem.childItemUsage || 0;

	return calculateTotalOrderQty(productQty, usage, detailItem.lossPercent, fixLossqty);
};


const recalculateDetailListWithTransport = (
	detailList: KSK2021_R01DetailDto[],
	editHeader: KSK2021_R01HeaderDto | null,
): KSK2021_R01DetailDto[] => {
	const allocatedQtyMap = new Map<string, number>();

	return detailList.map(item => {
		const bomUsingQty = calculateBomUsingQty(editHeader, item);
		const groupKey = getDetailGroupKey(item);
		const currentAllocated = allocatedQtyMap.get(groupKey) || 0;
		const remainingNeeded = Math.max(0, bomUsingQty - currentAllocated);

		let transportQty = 0;
		if (remainingNeeded > 0) {
			transportQty = Math.min(remainingNeeded, item.lotQty);
		}

		allocatedQtyMap.set(groupKey, currentAllocated + transportQty);

		let isModified: boolean;
		if (transportQty === item.transportQty) {
			isModified = item.isModified;
		} else {
			isModified = transportQty !== 0;
		}

		if (transportQty === 0) {
			isModified = false;
		}

		return { ...item, bomUsingQty, transportQty, isModified };
	});
};

export const defaultKSK2021_R01Filter : KSK2021_R01Filter = {
	labelPrintAuto: 'N',
};


const getInitialKSK2021_R01HeaderDto = (): KSK2021_R01HeaderDto => {
	const { compCdList, workPlaceList, wmsCdList, warehouseCdList, itemStatusList } = useCommonCodeStore.getState();

	const defaultLogicCenter = wmsCdList?.[0]?.minorCd || '';
    
    const warehouseCdListToUse = warehouseCdList.filter(value => (value.logicCenter === defaultLogicCenter
        && (value.productYn === 'Y' || value.manufactYn === 'Y' )
    ));
    const outWarehouseCdListToUse = warehouseCdList.filter(value => (value.logicCenter === defaultLogicCenter
        && (value.materialYn === 'Y' || value.manufactYn === 'Y' )
    ));
    const badWarehouseCdListToUse = warehouseCdList.filter(value => (value.logicCenter === defaultLogicCenter
        && value.badYn === 'Y'
    ));

	return {
		...defaultKSK2021_R01HeaderDto,
		compCd: compCdList?.[0]?.compCd || '',
		workplaceCd: workPlaceList?.[0]?.workplaceCd || '',
		logicCenter: defaultLogicCenter,
        warehouseCd: warehouseCdListToUse?.[0]?.warehouseCd || '',
        outWarehouseCd: outWarehouseCdListToUse?.[0]?.warehouseCd || '',
        badWarehouseCd: badWarehouseCdListToUse?.[0]?.warehouseCd || '',
        itemStatus: itemStatusList?.[0]?.minorCd || '',
		itemCd: '',
		itemNm: '',
	}
};

export const useKSK2021_R01Store = create<Store_KSK2021_R01>((set, get) => ({
	KSK2021_R01Filter: defaultKSK2021_R01Filter,
	KSK2021_R01PastFilter: defaultKSK2021_R01Filter,
	setKSK2021_R01Filter: (update) => set((state) => ({
		KSK2021_R01Filter: {
			...state.KSK2021_R01Filter,
			...update
		}
	})),
	setKSK2021_R01PastFilter: (filter: Store_KSK2021_R01['KSK2021_R01PastFilter']) => set((state) => {
		return {
			...state,
			KSK2021_R01PastFilter: filter
		}
	}),

	// ====== 생산실적 리스트 및 선택/편집 ======
	KSK2021_R01List: [],
	setKSK2021_R01List: (salesList: KSK2021_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			KSK2021_R01List: salesList
		}
	}),

	editKSK2021_R01: getInitialKSK2021_R01HeaderDto(),
	setEditKSK2021_R01: (editHeader: KSK2021_R01HeaderDto | null) => set((state) => {
		const productQtyChanged = editHeader != null
			&& state.editKSK2021_R01?.productQty !== editHeader.productQty;

		const newDetailList = productQtyChanged
			? recalculateDetailListWithTransport(state.KSK2021_R01DetailList, editHeader)
			: state.KSK2021_R01DetailList;

		return {
			...state,
			editKSK2021_R01: editHeader,
			KSK2021_R01DetailList: newDetailList,
		}
	}),

	// ====== 자재출고 상세(디테일) 데이터 ======
	KSK2021_R01DetailList: [],
	setKSK2021_R01DetailList: (data: KSK2021_R01DetailDto[]) => set((state) => {
		let newList: KSK2021_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultKSK2021_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			KSK2021_R01DetailList: newList
		}
	}),
	insertKSK2021_R01DetailList: (data: KSK2021_R01DetailDto[], index?: number) => set((state) => {
		let newKSK2021_R01DetailList = [...state.KSK2021_R01DetailList];

		let targetRowData = newKSK2021_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newKSK2021_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newKSK2021_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newKSK2021_R01DetailList = newKSK2021_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newKSK2021_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultKSK2021_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newKSK2021_R01DetailList.splice(index, 0, ...newData);
		} else {
			newKSK2021_R01DetailList.push(...newData);
		}

		return {
			...state,
			KSK2021_R01DetailList: newKSK2021_R01DetailList
		}
	}),
	removeKSK2021_R01DetailList: (index: number) => set((state) => {
		const newKSK2021_R01DetailList = [...state.KSK2021_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			KSK2021_R01DetailList: newKSK2021_R01DetailList
		}
	}),
	updateKSK2021_R01DetailList: (valueIndex: number, data: KSK2021_R01DetailDto) => set((state) => {
		const _KSK2021_R01DetailList = state.KSK2021_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? { ...data, isModified: true } : item
		);

		if(data.transportQty < 0) {
			showWarning('출고량은 0보다 작을 수 없습니다.');
			data.transportQty = 0;
		}
		return {
			...state,
			KSK2021_R01DetailList: _KSK2021_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedKSK2021_R01DetailList: [],
	setDeletedKSK2021_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedKSK2021_R01DetailList: idList
		}
	}),
	addDeletedKSK2021_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedKSK2021_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.KSK2021_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.KSK2021_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedKSK2021_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedKSK2021_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedKSK2021_R01DetailList: [...state.deletedKSK2021_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedKSK2021_R01DetailList: [],
	setSelectedKSK2021_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedKSK2021_R01DetailList: idList
		}
	}),
	addSelectedKSK2021_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedKSK2021_R01DetailList = [...state.selectedKSK2021_R01DetailList];
		if(idList.length > 0) {
			_selectedKSK2021_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedKSK2021_R01DetailList: _selectedKSK2021_R01DetailList
		}
	}),
	removeSelectedKSK2021_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedKSK2021_R01DetailList: [...state.selectedKSK2021_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedKSK2021_R01DetailList: () => set({ selectedKSK2021_R01DetailList: [] }),	

	originalKSK2021_R01DetailList: [],
	setOriginalKSK2021_R01DetailList: (data: KSK2021_R01DetailDto[]) => set((state) => {
		let newList: KSK2021_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultKSK2021_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK2021_R01DetailList: newList
		}
	}),

	// ====== 생산실적 불량 상세(디테일) 데이터 ======
	KSK2021_R01InspectList: [],
	setKSK2021_R01InspectList: (data: KSK2021_R01InspectDto[]) => set((state) => {
		let newList: KSK2021_R01InspectDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultKSK2021_R01InspectDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			KSK2021_R01InspectList: newList
		}
	}),
	insertKSK2021_R01InspectList: (data: KSK2021_R01InspectDto[], index?: number) => set((state) => {
		const newKSK2021_R01InspectList = [...state.KSK2021_R01InspectList];

		//let valueIndex = newSYS4100_R01List.length + 1;
		let valueIndex = Math.max(0, ...newKSK2021_R01InspectList.map(item => item.valueIndex || 0)) + 1;
		let targetOrderIndex = index ? index : 1;
		// 같은 orderIndex를 가진 행들 중에서 가장 큰 orderIndexSeq 값을 찾는다.
		const maxOrderIndexSeq = Math.max(0, ...newKSK2021_R01InspectList
			.filter(item => item.orderIndex === targetOrderIndex)
			.map(item => item.orderIndexSeq || 0)
		);
		let targetOrderIndexSeq = maxOrderIndexSeq + 1;
		// console.log('newKSK2021_R01InspectList : ', newKSK2021_R01InspectList);
		// console.log('valueIndex : ', valueIndex 
		// 				+ ' 멤버 index : ' + index
		// 				+ ' 최종 orderIndex : ' + targetOrderIndex
		// 				+ ' 최종 orderIndexSeq : ' + targetOrderIndexSeq
		// 			);
		
		const newData = data.map(item => ({ ...defaultKSK2021_R01InspectDto, ...item, 
			valueIndex: valueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: targetOrderIndexSeq
		}));
		if (index !== undefined) {
			newKSK2021_R01InspectList.splice(index, 0, ...newData);
		} else {
			newKSK2021_R01InspectList.push(...newData);
		}
		return {
			...state,
			KSK2021_R01InspectList: newKSK2021_R01InspectList
		}
	}),
	removeKSK2021_R01InspectList: (index: number) => set((state) => {
		const newKSK2021_R01InspectList = [...state.KSK2021_R01InspectList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			KSK2021_R01InspectList: newKSK2021_R01InspectList
		}
	}),
	updateKSK2021_R01InspectList: (valueIndex: number, data: KSK2021_R01InspectDto) => set((state) => ({
		...state,
		KSK2021_R01InspectList: state.KSK2021_R01InspectList.map(item =>
			item.valueIndex === valueIndex ? data : item
		),
	})),

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedKSK2021_R01InspectList: [],
	setDeletedKSK2021_R01InspectList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedKSK2021_R01InspectList: idList
		}
	}),
	addDeletedKSK2021_R01InspectList: (idList: string[]) => set((state) => {
		const _deletedLotList = [...state.deletedKSK2021_R01InspectList];

		for(const valueIndex of idList) {
			const isInserted = state.KSK2021_R01InspectList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.KSK2021_R01InspectList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedLotList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedKSK2021_R01InspectList: _deletedLotList
		}
	}),
	removeDeletedKSK2021_R01InspectList: (idList?: string[]) => set((state) => ({
		...state,
		deletedKSK2021_R01InspectList: [...state.deletedKSK2021_R01InspectList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedKSK2021_R01InspectList: [],
	setSelectedKSK2021_R01InspectList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedKSK2021_R01InspectList: idList
		}
	}),
	addSelectedKSK2021_R01InspectList: (idList: string[]) => set((state) => {
		const _selectedKSK2021_R01InspectList = [...state.selectedKSK2021_R01InspectList];
		if(idList.length > 0) {
			_selectedKSK2021_R01InspectList.push(...idList);
		}
		return {
			...state,
			selectedKSK2021_R01InspectList: _selectedKSK2021_R01InspectList
		}
	}),
	removeSelectedKSK2021_R01InspectList: (idList?: string[]) => set((state) => ({
		...state,
		selectedKSK2021_R01InspectList: [...state.selectedKSK2021_R01InspectList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedKSK2021_R01InspectList: () => set({ selectedKSK2021_R01InspectList: [] }),

	originalKSK2021_R01InspectList: [],
	setOriginalKSK2021_R01InspectList: (data: KSK2021_R01InspectDto[]) => set((state) => {
		let newList: KSK2021_R01InspectDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultKSK2021_R01InspectDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK2021_R01InspectList: newList
		}
	}),
	
	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	inspectColumnState: null,
	setInspectColumnState: (state: ColumnState[] | null) => set({ inspectColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

	notProductResult: true,
	setNotProductResult: (notProductResult: boolean) => set({ notProductResult }),

	modalVisible: false,
	setModalVisible: (modalVisible: boolean) => set({ modalVisible }),

	workTimeModalVisible: false,
	setWorkTimeModalVisible: (workTimeModalVisible: boolean) => set({ workTimeModalVisible }),

	workTimeModalType: null,
	setWorkTimeModalType: (workTimeModalType: 'start' | 'end' | null) => set({ workTimeModalType }),

	isDetailMaximized: false,
	setIsDetailMaximized: (value: boolean) => set({ isDetailMaximized: value }),

	isInitialLoad: true,
	setIsInitialLoad: (isInitialLoad: boolean) => set({ isInitialLoad }),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		KSK2021_R01Filter: defaultKSK2021_R01Filter,
		KSK2021_R01PastFilter: defaultKSK2021_R01Filter,
		KSK2021_R01List: [],
		editKSK2021_R01: getInitialKSK2021_R01HeaderDto(),

		KSK2021_R01DetailList: [],
		deletedKSK2021_R01DetailList: [],
		selectedKSK2021_R01DetailList: [],
		originalKSK2021_R01DetailList: [],

		KSK2021_R01InspectList: [],
		deletedKSK2021_R01InspectList: [],
		selectedKSK2021_R01InspectList: [],
		originalKSK2021_R01InspectList: [],

		allCount: 0,
		
		isInitialLoad: true,
	})),

	warehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		return warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& (value.goodsYn === 'Y' || value.productYn === 'Y')
		));
	},
	outWarehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		return warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& (value.manufactYn === 'Y')
		));
	},
	badWarehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		return warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& value.badYn === 'Y'
		));
	},

	// 공통코드 로드 후 초기값 동기화
	syncInitialData: () => {
		const { compCdList, workPlaceList, wmsCdList, itemStatusList } = useCommonCodeStore.getState();
		const state = get();
		
		if (compCdList.length === 0) return;

		const defaultCompCd = compCdList?.[0]?.compCd || '';
		const defaultWorkplaceCd = workPlaceList?.[0]?.workplaceCd || '';
		const defaultLogicCenter = wmsCdList?.[0]?.minorCd || '';
		const defaultItemStatus = itemStatusList?.[0]?.minorCd || '';

		const warehouseCdListToUse = state.warehouseCdListToUseList(defaultLogicCenter);
		const outWarehouseCdListToUse = state.outWarehouseCdListToUseList(defaultLogicCenter);
		const badWarehouseCdListToUse = state.badWarehouseCdListToUseList(defaultLogicCenter);

		const defaultWarehouseCd = warehouseCdListToUse?.[0]?.warehouseCd || '';
		const defaultOutWarehouseCd = outWarehouseCdListToUse?.[0]?.warehouseCd || '';
		const defaultBadWarehouseCd = badWarehouseCdListToUse?.[0]?.warehouseCd || '';

		let newFilter = state.KSK2021_R01Filter;
		let newEditHeader = state.editKSK2021_R01;
		let needUpdate = false;

		if (state.editKSK2021_R01 && (!state.editKSK2021_R01.compCd || !state.editKSK2021_R01.logicCenter)) {
			newEditHeader = {
				...state.editKSK2021_R01,
				compCd: defaultCompCd,
				workplaceCd: defaultWorkplaceCd,
				logicCenter: defaultLogicCenter,
				warehouseCd: defaultWarehouseCd,
				outWarehouseCd: defaultOutWarehouseCd,
				badWarehouseCd: defaultBadWarehouseCd,
				itemStatus: defaultItemStatus,
			};
			needUpdate = true;
		}

		if (needUpdate) {
			set({
				editKSK2021_R01: newEditHeader
			});
		}
	},

	
}));
